import API from 'services/api';

interface ILogType {
  logTypeId: string;
  group: string;
  code: string;
  title: string;
}

export const getCalculationLogTypes = (): Promise<ILogType[]> =>
  API.get('/api/log-types?EqualsTo[group]=KAL-SMJ').then(response => response?.data);
